import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import type {CmPictureType} from "../types";
import {getAiGeneratedImageHintText, isAiGeneratedImage} from "../../utility/aiGeneratedImage";
const NOTICE_MIN_HEIGHT = '32px';

interface Props {
    picture?: CmPictureType | null;
}

function CCOAiGeneratedImageNotice(props: Props) {
    const {t} = useTranslation();
    if (!isAiGeneratedImage(props.picture)) {
        return null;
    }
    return <Box
        data-cypress="aiGeneratedImageNotice"
        sx={{
            alignItems: 'center',
            backgroundColor: 'grey.100',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            minHeight: NOTICE_MIN_HEIGHT,
            px: 2,
            width: '100%'
        }}
    >
        <Typography
            component="p"
            variant="caption"
            sx={{
                color: 'text.primary',
                letterSpacing: 0,
                lineHeight: '20px',
                m: 0,
                textAlign: 'center',
                textDecoration: 'none !important',
            }}
        >
            {getAiGeneratedImageHintText(props.picture) ?? t('aiGeneratedImageHint')}
        </Typography>
    </Box>
}

export default CCOAiGeneratedImageNotice;
